module.exports = __webpack_public_path__ + "static/media/lens1.14802e09.png";